import React, { useEffect, useMemo } from "react";
import PortalNav from "features/EnterprisePortal/Components/PortalNav";
import { useSelector } from "react-redux";
import { brandingSelector, isSuperUserSelector, getPortalUrl } from "Utils/selectors";

export interface PortalNavOnLegacyProps {
   wrapper?: HTMLElement,
   footer?: HTMLElement,
   selectedPageName?: string
}
export const PortalNavOnLegacy: React.FC<PortalNavOnLegacyProps> = function ({ selectedPageName, wrapper, footer }) {
   const branding = useSelector(brandingSelector);
   const isSuperUser = useSelector(isSuperUserSelector);
   const isPortalNavVisible = useMemo(() => !!getPortalUrl(branding) && !isSuperUser, [branding, isSuperUser])
   
   useEffect(() => {
      if(wrapper) {
         if (isPortalNavVisible)
            wrapper.classList.add("portal-nav--visible");
         else
            wrapper.classList.remove("portal-nav--visible");
      }

      if(footer) {
         if (isPortalNavVisible)
            footer.classList.add("footer-portal-nav-shift");
         else
            footer.classList.remove("footer-portal-nav-shift");
      }
   }, [wrapper, footer, isPortalNavVisible]);

   if (isPortalNavVisible)
      return (<PortalNav baseUrl={branding?.url || ""} isMatchOverride={(to) => !!selectedPageName && to.endsWith(selectedPageName)} variant="minimized" />);
   else
      return null;
}


